/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injector, Injectable} from '@angular/core';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class TierResource {
  private readonly resource: any;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService,
    injector: Injector
  ) {
    this.resource = createAdnHttpResource(
      createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
      'tiers',
      () => injector.get(LocalUserProfile)
    );
  }

  query(a?: any, b?: any, c?: any, d?: any): any {
    return this.resource.query(a, b, c, d);
  }

  get(a?: any, b?: any, c?: any, d?: any): any {
    return this.resource.get(a, b, c, d);
  }

  create(data: any): any {
    return new this.resource(data);
  }
}
